export default "__VITE_ASSET__EndscCPe__"